import { Component, OnInit, Input } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as $ from 'jquery';

@Component({
  selector: 'cli-ems-tooltip-modal',
  templateUrl: './ems-tooltip-modal.component.html',
  styleUrls: ['./ems-tooltip-modal.component.scss']
})
export class EmsTooltipModalComponent implements OnInit {

  private subject: Subject<string>;
  
  @Input()
  public id: string;
  @Input()
  public message: string;
  @Input()
  public header: string;

  constructor() {

    this.header = environment.MODAL_HEADER;
    this.id = 'emsTooltipModal';
  }

  ngOnInit() {
  }

  public openModal(): Observable<string> {

    $(`#${this.id}`).modal();

    this.subject = new Subject<string>();

    return this.subject.asObservable();
  }

  public proceedYes() {


    this.closeModal();

    this.subject.next('Yes');
    this.subject.complete();
  }

  public proceedCancel() {
    this.closeModal();

    this.subject.next('Cancel');
    this.subject.complete();
  }

  public closeModal() {
    $('#' + this.id).modal('hide');     
  }

}
